import {
  Box,
  Typography,
  useTheme
} from '@mui/material'
import {
  ConfirmationNumber
} from '@mui/icons-material'
import { TicketListCard } from '../../components/TicketListCard'

function Tickets() {
  const theme = useTheme()

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <ConfirmationNumber sx={{ fontSize: 32, color: theme.palette.primary.main }} />
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Tickets Overview
        </Typography>
      </Box>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        View and manage all support tickets across your organization.
      </Typography>

      <TicketListCard
        variant="admin"
        showOrganizationFilter={true}
        showCreateButton={true}
      />
    </Box>
  )
}

export default Tickets
